import Form from "antd/lib/form";
import ZTypography from "@atoms/ZTypography";
import {
	EWidgets,
	IFormFieldProps,
	IFormProps,
	IFormSectionProps
} from "@organisms/ZForm/interface";
import { IMissingDetailsModalProps } from "@organisms/ZMissingDetailsModal/interface";
import Col from "antd/lib/col";
import Row from "antd/lib/row";
import ZForm from "@organisms/ZForm";
import React from "react";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { capitalizeFirstLetter } from "@/Contracts/Utils";

const MissingDetailsSection: React.FC<IMissingDetailsModalProps> = props => {
	const form = Form.useForm();
	const customFields: IFormFieldProps[] =
		props.missingEmailKeys.map<IFormFieldProps>(
			(missingClientContact, index) => ({
				key: `email_fields_form_values.${missingClientContact.id}.email`,
				widget: EWidgets.INPUT,
				required: true,
				message: "Email is required",
				label: capitalizeFirstLetter(missingClientContact.name),
				widgetProps: {
					placeholder: "Enter email",
					"data-testid": `missing-email-${index}`,
					className: "w-full"
				},
				rules: [
					{
						type: "email",
						message: "Please enter a valid email address"
					}
				],
				normalize: value => value.trim()
			})
		);

	const formSections: Array<IFormSectionProps> = [
		{
			meta: {
				formItemLayout: [9, 15],
				fields: customFields
			}
		}
	];

	const formProps: IFormProps = {
		form: props.form ?? form[0],
		sections: formSections,
		key: "MissingDetailsForm",
		layout: "horizontal",
		isRightFooter: true,
		isSubmitAllowed: false,
		requiredMark: false
	};

	return (
		<>
			<ZTypography.ZText className="text-gray-7">
				{props.subtitle}
			</ZTypography.ZText>
			<Row className="mt-6 mb-4">
				<Col span={9}>
					<ZTypography.ZText weight={EFontWeights.MEDIUM}>
						Recipient’s Name
					</ZTypography.ZText>
				</Col>
				<Col span={15}>
					<ZTypography.ZText weight={EFontWeights.MEDIUM}>
						Email
					</ZTypography.ZText>
				</Col>
			</Row>
			<ZForm {...formProps} className="missing-email-section" />
		</>
	);
};

export default MissingDetailsSection;
